import { useMemo } from 'react';
import { useWorkspace } from '@/shared/hooks/useWorkspace';

/**
 * Check if personal templates are enabled for the workspace.
 */
export function useIsPersonalTemplatesEnabled() {
  const { workspace, isLoading } = useWorkspace();

  const aiFeatureEnabled = workspace?.settings.ai_feature_enabled ?? false;
  const enablePersonalTemplates =
    workspace?.settings.enable_personal_templates ?? true;

  const isPersonalTemplatesEnabled =
    aiFeatureEnabled && enablePersonalTemplates;

  return useMemo(
    () => ({ isPersonalTemplatesEnabled, isLoading }),
    [isPersonalTemplatesEnabled, isLoading],
  );
}
